import { ActiveOrder } from '@/resources/types'
import { createContext, useContext } from 'react'

export type OrdersWebSocketContextType = {
  orders: ActiveOrder[]
  isConnected: boolean
  isLoading: boolean
  isActive: boolean
  hasUpdatedOrders: boolean
}

export const OrdersWebSocketContext = createContext<OrdersWebSocketContextType>(
  {
    orders: [],
    isConnected: false,
    isLoading: false,
    isActive: false,
    hasUpdatedOrders: false,
  }
)

const useOrdersWebSocket = () => {
  const context = useContext(OrdersWebSocketContext)
  if (!context) {
    throw new Error(
      'useOrdersWebSocket must be used within OrdersWebSocketContext'
    )
  }
  return context
}

export default useOrdersWebSocket
